import * as React from 'react'

import { Table } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  hasCorrectiveBreaks: boolean
  hasExtraHourManagementV2: boolean
  showExtraHoursColumn: boolean
  showComplementaryHoursColumn: boolean
}

const TableHeader = ({
  hasCorrectiveBreaks,
  hasExtraHourManagementV2,
  showExtraHoursColumn,
  showComplementaryHoursColumn,
}: Props) => {
  return (
    <Table.Head>
      <Table.Row>
        <Table.HeadCell background="grey000White" width={122}>
          {i18n.t('clock_in.table.header.day')}
        </Table.HeadCell>
        <Table.HeadCell background="grey000White" paddingX="s24">
          {i18n.t('clock_in.worked_hours_title')} / {i18n.t('clock_in.planned_hours')}
        </Table.HeadCell>
        {hasExtraHourManagementV2 && (
          <Table.HeadCell background="grey000White" paddingX="s24">
            {i18n.t('clock_in.balance_header.title')}
          </Table.HeadCell>
        )}
        {hasCorrectiveBreaks && (
          <Table.HeadCell background="grey000White" paddingX="s24">
            {i18n.t('clock_in.breaks.title')}
          </Table.HeadCell>
        )}
        {showExtraHoursColumn && !showComplementaryHoursColumn && (
          <Table.HeadCell background="grey000White" paddingX="s24">
            {i18n.t('clock_in.extra_hours.title')}
          </Table.HeadCell>
        )}
        {showComplementaryHoursColumn && (
          <Table.HeadCell background="grey000White" paddingX="s24">
            {i18n.t('clock_in.complementary_hours.title')}
          </Table.HeadCell>
        )}
        <Table.HeadCell background="grey000White" paddingX="s24">
          {i18n.t('time_tracking.table.headers.absences')}
        </Table.HeadCell>
        <Table.HeadCell background="grey000White" width={128}></Table.HeadCell>
      </Table.Row>
    </Table.Head>
  )
}
export default TableHeader
